import React from "react";
import { get } from "../../../api/axios";

export const useCities = () => {
    const [cities, setCities] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        setLoading(true);
        get("/ciudades")
            .then((response) => {
                setCities(response.data || []);
                setError(null);
            })
            .catch(() => {
                setError("No se pudieron cargar las ciudades");
            })
            .finally(() => setLoading(false));
    }, []);

    return { cities, loading, error };
};
